/******************************************************************************
Tree Replant Reducer: Handles all interactions & state changes with the tree replant
component.
Hawaiian Macadamia Nut Services
Alexander Self
03/27/20
*******************************************************************************/
import { ADD_EMPLOYEE, REMOVE_EMPLOYEE, PREPARE_REPLANT, FETCH_REPLANTS, CLEAR_FORM,
  CREATE_REPLANT, SET_REPLANT_TO_EDIT, ADD_EMPLOYEE_TO_EDIT, REMOVE_EMPLOYEE_FROM_EDIT,
  EDIT_REPLANT, SET_REPLANT_TO_DELETE, DELETE_REPLANT } from '../actions/types';
let initState = {
  replants: [],
  edit: {
    addedEmployees: []
  },
  delete: {},
  app: {
    addedEmployees: [],
    employees: [],
    prevReplants: [],
    inventoryTransaction: {}
  },
  editing: false
};

export default function TreeReplantReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_REPLANTS:
      return { ...state,
        replants: action.payload
      };
    case CREATE_REPLANT:
      return { ...state,
        replants: state.replants.concat(action.payload),
        app: initState.app
      };
    case EDIT_REPLANT:
      return { ...state,
        replants: state.replants.filter((r) => r.id !== state.edit.id).concat(action.payload),
        edit: initState.edit,
        editing: initState.editing
      };
    case DELETE_REPLANT:
      return { ...state,
        replants: state.replants.filter((r) => r.id !== state.delete.id),
        delete: initState.delete
      };
    case ADD_EMPLOYEE:
      if (state.app.addedEmployees.find((e) => e.eid === action.payload.eid)) return state;
      return { ...state,
        app: { ...state.app,
          addedEmployees: state.app.addedEmployees.concat(action.payload)
        }
      };
    case REMOVE_EMPLOYEE:
      return { ...state,
        app: { ...state.app,
          addedEmployees: state.app.addedEmployees.filter((e) => e.eid !== action.payload.eid)
        }
      };
    case PREPARE_REPLANT:
      return { ...state,
        app: { ...state.app,
          ...action.payload
        }
      };
    case SET_REPLANT_TO_EDIT:
      return { ...state,
        edit: { ...state.edit,
          ...action.payload,
          addedEmployees: action.payload.employees
        },
        editing: true
      };
    case ADD_EMPLOYEE_TO_EDIT:
      if (state.edit.addedEmployees.find((e) => e.eid === action.payload.eid)) return state;
      return { ...state,
        edit: { ...state.edit,
          addedEmployees: state.edit.addedEmployees.concat(action.payload)
        }
      };
    case REMOVE_EMPLOYEE_FROM_EDIT:
      return { ...state,
        edit: { ...state.edit,
          addedEmployees: state.edit.addedEmployees.filter((e) => e.eid !== action.payload.eid)
        }
      };
    case SET_REPLANT_TO_DELETE:
      return { ...state,
        delete: action.payload
      };
    case CLEAR_FORM:
      return { ...state,
        app: initState.app
      };
    default:
      return state;
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/tree_replant_reducer.js